<template>
  <div class="schedule">
    <div class="schedule_title">
      2. Asesoría pedagógica
    </div>
    <div class="schedule_description">
      Un asesor pedagógico se comunicará contigo para determinar tu nivel
      comunicativo en el idioma. Además te orientará sobre los programas y
      modalidades de estudio ideales para ti.
    </div>
    <div class="schedule_description">
      Elige una de las opciones para realizar tu asesoría:
    </div>
    <!-- <div class="schedule_question">
            ¿Cuándo desearías la asesoría?
        </div> -->
    <div class="schedule_form">
      <v-form>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="dateFormatted"
                  filled
                  label="¿Cuándo?"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  single-line
                  prepend-inner-icon="mdi-calendar"
                  required
                  :error-messages="dateError"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                @input="menu1 = false"
                :min="minDate"
                :max="endDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-select
              :items="timeSelected"
              menu-props="auto"
              label="¿A qué hora?"
              filled
              prepend-inner-icon="schedule"
              single-line
              v-model="time"
              no-data-text="No se encontraron horarios disponibles."
              required
              :error-messages="timeError"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <div class="call">
            <!-- <div class="call_subtitle">
                        Llamada telefónica
                    </div> -->
            <div class="call_description">
              Te llamaremos al <span>número que registraste...</span>
            </div>
            <div class="call_cellphone">
              <span class="material-icons">
                call
              </span>
              <div class="call_cellphone_number" v-if="user">
                {{ user.phone }}
              </div>
            </div>
            <div class="call_alternative_title">
              ... o si lo deseas, puedes indicar otro número
            </div>

            <div class="call_alternative_number">
              <v-text-field
                single-line
                filled
                v-model="phone"
                required
                label="Número de celular"
                :error-messages="phoneError"
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
                @keypress="isPhoneNumber($event)"
              ></v-text-field>
            </div>
          </div>
        </v-row>
      </v-form>
    </div>
    <div class="schedule_footer">
      <v-btn
        color="primary"
        class="uppercase"
        @click="nextStep"
        :loading="buttonLoading"
      >
        {{
          time && time.toLowerCase().search("ahora") > -1
            ? "Continuar"
            : "Guardar"
        }}
      </v-btn>
    </div>
    <v-dialog
      v-model="scheduledAdvice"
      persistent
      content-class="schedule_dialog"
    >
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="onClose()">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="schedule_dialog_title">
            Su asesoría ha sido programada
          </div>
          <div class="schedule_dialog_date mb-8" v-if="adviceDate">
            <span>{{ adviceDate.format("DD/MM/YYYY") }}</span> a las
            <span>{{ adviceDate.format("HH:mm") }}</span>
          </div>
          <div class="schedule_dialog_recommendation">
            Le recomendamos agendar esta fecha en su calendario.
          </div>
          <div class="schedule_dialog_image">
            <img src="@/assets/images/evaluation/schedule.svg" alt="" />
          </div>
          <div class="schedule_dialog_footer">
            <v-btn color="primary" class="uppercase" @click="toHome()">
              ir al home
            </v-btn>

            <v-btn
              color="primary"
              class="uppercase outline"
              v-if="isEditable"
              @click="
                scheduledAdvice = false;
                buttonLoading = false;
              "
            >
              modificar horario
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="scheduleNoFound"
      persistent
      content-class="schedule_dialog"
    >
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="scheduleNoFound = false">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="schedule_dialog_title">
            Puede elegir otro horario
          </div>
          <div class="schedule_dialog_description mb-9">
            Lamentablemente no hay asesores pedagógicos disponibles en el
            horario seleccionado.
          </div>
          <div class="schedule_dialog_image">
            <img src="@/assets/images/evaluation/scheduleNoFound.svg" alt="" />
          </div>
          <div class="schedule_dialog_footer mt-5 mb-7">
            <v-btn
              color="primary"
              class="uppercase"
              @click="scheduleNoFound = false"
            >
              CERRAR
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
const { required, requiredIf } = require("vuelidate/lib/validators");

import axios from "@/axios-auth";
import { mapGetters, mapMutations, mapActions } from "vuex";
import moment from "moment";
moment.locale("es-do");

export default {
  data: vm => {
    return {
      time: null,
      user: null,
      scheduleList: [],
      timeSelected: [],
      minDate: moment().format("YYYY-MM-DD"),
      scheduledAdvice: false,
      scheduleNoFound: false,
      now: "",
      nowTime: "",
      currentAdvices: null,
      adviceDate: "",
      isEditable: false,
      inProgress: false,
      endDate: moment().format("YYYY-MM-DD"),
      buttonLoading: false,

      date2: moment().format("YYYY-MM-DD"),

      dateFormatted: vm.formatDate2(moment().format("YYYY-MM-DD")),
      menu1: false,
      timerControl: null,

      phone: ""
    };
  },
  mixins: [validationMixin],
  validations: {
    time: { required },
    date2: { required },
    phone: {
      requiredIf: requiredIf(function() {
        console.log(this.phone.length);
        console.log(this.phone.length > 0 && this.phone.length < 9);
        return this.phone.length > 0 && this.phone.length < 9;
      })
    }
  },
  methods: {
    ...mapMutations(["setAdvisory", "setPhone"]),
    ...mapActions(["verifyPostulation"]),
    formatDate2(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    onClose() {
      this.buttonLoading = false;
      this.isEditable
        ? (this.scheduledAdvice = false)
        : this.$router.push({ path: `/principal` });
    },
    nextStep() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.registerSchedule();
      }
    },
    toHome() {
      this.scheduledAdvice = false;
      this.$router.push({ path: `/principal` });
    },
    sendMail() {
      let m = moment(this.date2);

      let data_email = {
        name: this.user.first_name,
        fullname: `${this.user.first_name} ${this.user.second_name} ${this.user.first_surname} ${this.user.second_surname}`,
        date: m.format("dddd, DD MMMM YYYY"),
        hour: this.time == this.now ? this.nowTime : this.time,
        place: process.env.VUE_APP_DEFAULT_PLACE_ADVICE,
        email: this.user.email,
        bcc: this.postulation.email_notification
          ? this.postulation.email_notification
          : ""
      };

      axios
        .post(`users/send-mail-confirmed-advice-up/`, data_email, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          // console.log(response);
        })
        .catch(err => {
          console.log(err);
        });
    },
    registerSchedule() {
      //TODO
      this.buttonLoading = true;
      let obj = {
        application_id: this.postulation.id,
        date: this.formatDate2(this.date2),
        time: this.time == this.now ? this.nowTime : this.time
      };
      axios
        .post(`users/register-schedule/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          if (this.phone != "") {
            this.setPhone(this.phone);
            this.cellphoneUpdate();
          }
          this.sendMail();
          this.setAdvisory(response.data);
          clearInterval(this.timerControl);

          if (this.time == this.now) {
            this.$emit("completed");
          } else {
            this.adviceDate = moment(this.date2 + " " + this.time);
            let momentNow = moment();

            if (
              Math.abs(this.adviceDate.diff(momentNow, "minutes")) >=
              process.env.VUE_APP_SCHEDULE_MINUTES_TO_CHANGE
            ) {
              this.isEditable = true;
            }
            this.scheduledAdvice = true;
          }
        })
        .catch(err => {
          this.scheduleNoFound = true;
          this.buttonLoading = false;
          console.log(err);
        });
    },
    cellphoneUpdate() {
      let obj = {
        application_id: this.postulation.id,
        phone: this.phone
      };
      axios
        .post(`users/phone-update/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          if (response) {
            console.log("actualizó celular");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadSchedule() {
      // console.log('loadSchedule');
      let obj = {
        language_id: this.language.id,
        program_id: this.program.id
      };
      axios
        .post(`users/list-schedule/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          this.scheduleList = response.data;

          if (this.date2 == moment().format("YYYY-MM-DD")) {
            this.dateFormatted = "Hoy";
          } else {
            this.dateFormatted = this.formatDate2(this.date2);
          }

          this.setHours();
        })
        .catch(err => {
          console.log(err);
        });
    },
    setHours() {
      let timeToFind = this.formatDate2(this.date2);
      let hours = this.scheduleList.find(s => s.date === timeToFind);

      this.timeSelected = hours ? hours.hours : [];

      if (this.timeSelected.length) {
        if (this.date2 == moment().format("YYYY-MM-DD")) {
          this.putNow();
          this.timerControl = setInterval(() => this.putNow(), 1 * 1000);
        } else {
          clearInterval(this.timerControl);
        }
      } else {
        if (!this.scheduledAdvice) {
          this.scheduleNoFound = true;
        }
      }
    },
    putNow() {
      let firtsElement = this.timeSelected[0];
      let index = firtsElement.toLowerCase().search("ahora");

      this.nowTime = moment()
        .add(parseInt(process.env.VUE_APP_SCHEDULE_EXTRA_MINUTES), "minutes")
        .format("HH:mm");
      this.now = this.nowTime + " (Ahora)";

      if (index < 0) {
        this.timeSelected.unshift(this.now);
      } else {
        if (firtsElement != this.now) {
          this.timeSelected.splice(0, 1, this.now);
          if (firtsElement == this.time) {
            this.time = this.now;
          }
        }
      }
    },
    validateIsEditable() {
      let momentNow = moment();

      if (
        Math.abs(this.adviceDate.diff(momentNow, "minutes")) >=
        process.env.VUE_APP_SCHEDULE_MINUTES_TO_CHANGE
      ) {
        this.isEditable = true;
      }
    },
    validateInProgress() {
      let momentNow = moment();

      if (
        this.adviceDate.diff(momentNow, "minutes") <=
        process.env.VUE_APP_SCHEDULE_GAP_MINUTES
      ) {
        this.inProgress = true;
      }
    },
    isPhoneNumber(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let selection = window
        .getSelection()
        .toString()
        .trim();
      if (selection && selection.length > 0 && selection === this.phone) {
        this.phone = "";
      }
      if (
        (this.phone && this.phone.length == 0 && char != 9) ||
        this.phone.length == 9
      ) {
        e.preventDefault();
      }
      if (/^[0-9]*$/.test(char)) return true;
      else e.preventDefault();
    }
  },
  computed: {
    ...mapGetters({
      language: "language",
      program: "program",
      postulation: "postulation",
      postulationIsNull: "postulationIsNull",
      examFinished: "examFinished",
      extraMinutes: "extraMinutes"
    }),
    phoneError() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.phone.requiredIf &&
        errors.push("Ingrese un número de celular correcto.");
      return errors;
    },
    isContinue() {
      return false;
    },
    dateError() {
      const errors = [];
      if (!this.$v.date2.$dirty) return errors;
      !this.$v.date2.required && errors.push("Este dato es requerido.");
      return errors;
    },
    timeError() {
      const errors = [];
      if (!this.$v.time.$dirty) return errors;
      !this.$v.time.required && errors.push("Este dato es requerido.");
      return errors;
    }
  },
  mounted() {
    this.user = this.$store.state.usuario;
    this.verifyPostulation();

    // console.log(this.postulation);
    // console.log(this.program);

    if (!this.postulationIsNull) {
      if (this.postulation.advices.length) {
        this.currentAdvices = this.postulation.advices[
          this.postulation.advices.length - 1
        ];

        this.adviceDate = moment(this.currentAdvices.date);
        switch (this.currentAdvices.status.id) {
          case 1:
            this.validateInProgress();
            this.validateIsEditable();

            if (this.inProgress) {
              this.$emit("goTo", "progress");
            } else {
              this.scheduledAdvice = true;
            }
            break;
          case 2:
            this.$emit("goTo", "progress");
            break;
        }
      }
      if (this.postulation.examns.length > 0) {
        let exam = this.postulation.examns[this.postulation.examns.length - 1];

        if (exam.end_date) {
          let d = moment(exam.end_date);
          this.endDate = d
            .add(
              parseInt(process.env.VUE_APP_DEADLINE_SCHEDULING_ADVICE),
              "days"
            )
            .format("YYYY-MM-DD");
        }
      } else if (!this.program.require_evaluation) {
        this.endDate = moment()
          .add(parseInt(process.env.VUE_APP_DEADLINE_SCHEDULING_ADVICE), "days")
          .format("YYYY-MM-DD");
      }

      if (this.$route.params["step"] == "schedule") {
        this.loadSchedule();
      }
    }
  },
  watch: {
    "$route.params.step": function(value) {
      // console.log('step:'+value);
      this.loadSchedule();
    },
    formatDate(val) {
      this.time = "";
      if (val) {
        this.setHours();
      }
    },
    examFinished(val) {
      if (val) {
        let d = moment(this.examFinished.end_date);
        this.endDate = d
          .add(parseInt(process.env.VUE_APP_DEADLINE_SCHEDULING_ADVICE), "days")
          .format("YYYY-MM-DD");
      }
    },
    date2(val) {
      if (this.date2 == moment().format("YYYY-MM-DD")) {
        this.dateFormatted = "Hoy";
      } else {
        this.dateFormatted = this.formatDate2(this.date2);
      }
      this.setHours();
    },
    nowTime(val) {
      // console.log('nowTime:'+val);
    }
  }
};
</script>
